import { Injectable } from '@angular/core';
import { AppDateAdapter } from 'src/app/shared/adapter/date.adapter';

@Injectable()
export class ShareWeeklyPlanningDateAdapter extends AppDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}
